import { QueueElement } from 'src/core/queue/domain/queue-element';
import { Task } from '../../../master-data/domain/task';

export abstract class TaskQueueElement extends QueueElement {
  task: Task;
}
